<block-ui></block-ui>
  <!-- Page Content -->
  <div class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="HelpCenterForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="HelpCenterForm"></BBSF-TextBox>
            <BBSF-TextBox [options]="ParentIdTextBox" [group]="HelpCenterForm" [hidden]="true">
            </BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <button type="button" title="Add" class="btn btn-sm btn-primary" (click)="showAddHelpCenterModal(AddHelpCenterModal)">
            <i class=" fa fa-plus"></i>{{utilityService.getResourceValue("Add")}}
          </button>
        </div>
      </div>
      <div class="card-body py-3">
        <div class="table-responsive">
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Title")}}</th>
                <th class="min-w-150px text-center">{{utilityService.getResourceValue("Visible")}}</th>
                <th class="text-center min-w-50">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let Item of HelpCenterPagingResult">

                <td>

                  <span *ngIf="language=='en'" class="text-dark">{{Item.title.english}}</span>
                  <span *ngIf="language=='ar'" class="text-dark">{{Item.title.arabic}}</span>

                  <a *ngIf="language=='ar'" (click)="SaveName(Item.title.arabic)"
                     [routerLink]="['/Admin/HelpCenter/ThirdLevel',Item.parentID]"
                     routerLinkActive="router-link-active" class=" text-dark">{{Item.title.arabic}}</a>
                </td>
                <td class="text-center">
                  <span *ngIf="Item.isHidden;else other_content">
                    <i class="fa fa-times"></i>
                  </span>
                  <ng-template #other_content>
                    <i class="fa fa-check"></i>
                  </ng-template>
                </td>
                <td class="text-center">
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button class="drop-item px-3" ngbDropdownItem
                              (click)="showEditHelpCenterModal(Item,EditHelpCenterModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </button>
                      <button ngbDropdownItem class="drop-item px-3" id="btnResetPass" (click)="showDeleteHelpCenterModal(Item,deleteHelpCenterItemModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
              <tr *ngIf="HelpCenterPagingResult.length == 0">
                <td colspan="3">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>

          <!--end::Permission list-->
        </div>
      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setHelpCenterItemListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="HelpCenterPaging" [group]="HelpCenterForm" #HelpCenterPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>


  <!--delete Modal-->
  <ng-template #deleteHelpCenterItemModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("HelpCenter")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteHelpCenterItemModal id="CloseDeleteHelpCenterItemModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteHelpCenter()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>

  <!--Edit Modal-->
  <ng-template #EditHelpCenterModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
          <img src="./src/assets/images/arr061.svg"/>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("HelpCenter")}}</h1>
      </div>
      <form [formGroup]="EditHelpCenterForm" (ngSubmit)="editHelpCenter()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="EditMultiLingualTitle" [group]="EditHelpCenterForm"></BBSF-MultiLingualTextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualHtmlEditor [options]="EditMultiLingualContent" [group]="EditHelpCenterForm"></BBSF-MultiLingualHtmlEditor>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="EditIsHidden" [group]="EditHelpCenterForm">
            </BBSF-CheckBox>
          </div>
        </div>

        <div class="text-center pt-7">
          <button #CloseEditHelpCenterModal id="CloseEditHelpCenterModal" type="button"
                  class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>
  <!--add Modal-->
  <ng-template #AddHelpCenterModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("HelpCenter")}}</h1>
      </div>
       <form [formGroup]="AddHelpCenterForm" 
              (ngSubmit)="addHelpCenterItem()">

        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualTextBox [options]="MultiLingualTitle" [group]="AddHelpCenterForm"></BBSF-MultiLingualTextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-MultiLingualHtmlEditor [options]="MultiLingualContent" [group]="AddHelpCenterForm"></BBSF-MultiLingualHtmlEditor>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12">
            <BBSF-CheckBox [options]="AddIsHidden" [group]="AddHelpCenterForm">
            </BBSF-CheckBox>
          </div>
        </div>
        <div class="text-center pt-7">
          <button  #CloseHelpCenterModal id="CloseAddHelpCenterModal" type="button"
                  class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>


